import { useEffect, useState } from "react";

export const useMovementDetection = () => {
    const [hasInteracted, setHasInteracted] = useState(false);

    useEffect(() => {
        const handleInteraction = () => {
            setHasInteracted(true);
        };

        window.addEventListener("mousemove", handleInteraction);
        window.addEventListener("touchmove", handleInteraction);
        window.addEventListener("scroll", handleInteraction);

        return () => {
            window.removeEventListener("mousemove", handleInteraction);
            window.removeEventListener("touchmove", handleInteraction);
            window.removeEventListener("scroll", handleInteraction);
        };
    }, []);

    return hasInteracted;
};

export default useMovementDetection;
